import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsRandomizationSchemaServices } from "../../../APIServices/EIWRS/eiwrsRandomizationSchemaServices";

const UpdateStudyRandomizationSchemaSeedNumber = ({
  randomizationSchemaData,
  getEIWRSRandomizationSchemaData,
  Show,
  Hide,
  Title,
}) => {
  const { studyId } = useParams()
  const [seedNumber, setSeedNumber] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const updateEIWRSRandomizationSchemaData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Seed Number!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = randomizationSchemaData?._id;
        userData.studyId = studyId;
        userData.seedNumber = seedNumber;
        userData.mode = StudyMode;
        let data = await eiwrsRandomizationSchemaServices.updateEIWRSRandomizationSchemaData(
          userData
        );
        if (data?.statusCode === 200) {
          getEIWRSRandomizationSchemaData();
          Hide();
          setSeedNumber("");
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    setSeedNumber(randomizationSchemaData?.seedNumber || "");
  }, [randomizationSchemaData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Seed Number{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="number"
              className="br3"
              placeholder="Enter Seed Number"
              value={seedNumber}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 8) {
                  setSeedNumber(value);
                }
              }}
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!seedNumber || buttonLoader}
            className="updateProfile"
            onClick={(e) => updateEIWRSRandomizationSchemaData(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              "Update Seed Number"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateStudyRandomizationSchemaSeedNumber;
